import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ProviderModel} from "../../../models/ProviderModel";
import {ProjectConstants} from "../../project-constants";
import {ContractualDataModel} from "../../../models/ContractualDataModel";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss']
})
export class TabGroupComponent extends ProjectConstants implements OnInit {
  selectedIndex: any;
  providerDefault: ProviderModel;
  parameterSubscribe: Subscription;

  @Input() reportSection?: boolean;

  constructor(private _Activatedroute: ActivatedRoute, private route: ActivatedRoute) {
    super();
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }
  ngOnInit() {
    this.providerDefault = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
  }

}
